module.exports = __webpack_public_path__ + "c756a8a2b232005d5755fa94f6fcadff.MP3";